import { createReducer, on } from '@ngrx/store';
import { IArticlesState, initialArticlesState } from './articles.state';
import { AllArticlesLoaded, ArticlesForGestiuneAppendInitialItems, ArticlesForGestiuneConsumabileAppendInitialItems, ArticlesForGestiuneConsumabileLoaded, ArticlesForGestiuneConsumabileLoading, ArticlesForGestiuneConsumabileNextPage, ArticlesForGestiuneConsumabileReset, ArticlesForGestiuneConsumabileSearch, ArticlesForGestiuneLoaded, ArticlesForGestiuneLoading, ArticlesForGestiuneNextPage, ArticlesForGestiuneReset, ArticlesForGestiuneSearch, ArticlesLoaded, ArticlesPaginatedAppendInitialItems, ArticlesPaginatedLoaded, ArticlesPaginatedLoading, ArticlesPaginatedNextPage, ArticlesPaginatedReset, ArticlesPaginatedSearch, ArticlesWithGestiuneAppendInitialItems, ArticlesWithGestiuneLoaded, ArticlesWithGestiuneLoading, ArticlesWithGestiuneNextPage, ArticlesWithGestiuneOnlySecondHand, ArticlesWithGestiuneReset, ArticlesWithGestiuneSearch } from './articles.actions';

const setArticles = (state: IArticlesState, { articles }: { articles: any[] }) => ({
  ...state,
  articles
});

const setArticlesWithGestiuneOnlySecondHand = (state: IArticlesState, { onlySecondHand }: { onlySecondHand: boolean }) => ({
  ...state,
  onlySecondHand
});

const setArticlesForGestiune = (state: IArticlesState, { articlesForGestiune }: { articlesForGestiune: any[] }) => {
  let newState: IArticlesState = {
    ...state,
    articlesForGestiune: [ ...state.articlesForGestiune, ...articlesForGestiune ],
    articlesForGestiuneLoading: false,
  };
  return newState;
}

const setArticlesPaginated = (state: IArticlesState, { articlesPaginated }: { articlesPaginated: any[] }) => {
  let newState: IArticlesState = {
    ...state,
    articlesPaginated: [ ...state.articlesPaginated, ...articlesPaginated ],
    articlesPaginatedLoading: false,
  };
  return newState;
}

const setArticlesWithGestiune = (state: IArticlesState, { articlesWithGestiune }: { articlesWithGestiune: [] }) => {
  let newState: IArticlesState = {
    ...state,
    articlesWithGestiune: [ ...state.articlesWithGestiune, ...articlesWithGestiune ],
    articlesWithGestiuneLoading: false,
  };
  return newState;
}

const setAllArticles = (state: IArticlesState, { articles }: { articles: any[] }) => {
  let allArticlesById = {};
  let allArticlesByCode = {};
  articles.forEach((article: any) => {
    allArticlesById[article.id] = article;
    allArticlesByCode[article.code] = article;
  });
 
  return {
    ...state,
    allArticles: articles,
    allArticlesById: allArticlesById,
    allArticlesByCode: allArticlesByCode
  };
};

const setArticlesForGestiuneConsumabile = (
  state: IArticlesState,
  { articlesForGestiune }: { articlesForGestiune: any[] }
) => ({
  ...state,
  articlesForGestiuneConsumabile: [
    ...state.articlesForGestiuneConsumabile,
    ...articlesForGestiune,
  ],
  articlesForGestiuneConsumabileLoading: false,
});

const _ArticlesReducer = createReducer<IArticlesState>(
  initialArticlesState,
  on(ArticlesLoaded, setArticles),
  on(AllArticlesLoaded, setAllArticles),
  on(ArticlesForGestiuneLoaded, setArticlesForGestiune),
  on(ArticlesForGestiuneLoading, (state: IArticlesState) => ({
    ...state,
    articlesForGestiuneLoading: true,
  })),
  on(ArticlesForGestiuneNextPage, (state: IArticlesState) => ({
    ...state,
    articlesForGestiunePage: state.articlesForGestiunePage + 1,
  })),
  on(ArticlesForGestiuneReset, (state: IArticlesState) => ({
    ...state,
    articlesForGestiune: [],
    articlesForGestiunePage: 0,
  })),
  on(ArticlesForGestiuneSearch, (state: IArticlesState, { search }) => ({
    ...state,
    articlesForGestiune: [],
    articlesForGestiuneSearch: search,
    articlesForGestiunePage: 0,
  })),
  on(ArticlesForGestiuneAppendInitialItems, (state: IArticlesState, { articlesForGestiune } : { articlesForGestiune : {articleId: string, name: string}[] }) => {
    return ({
      ...state,
      articlesForGestiune: [...state.articlesForGestiune, ...articlesForGestiune],
    }) 
  }),
  
  on(ArticlesPaginatedLoaded, setArticlesPaginated),
  on(ArticlesPaginatedLoading, (state: IArticlesState) => ({
    ...state,
    articlesPaginatedLoading: true,
  })),
    on(ArticlesPaginatedNextPage, (state: IArticlesState) => ({
    ...state,
    articlesPaginatedPage: state.articlesPaginatedPage + 1,
  })),
  on(ArticlesPaginatedReset, (state: IArticlesState) => ({
    ...state,
    articlesPaginated: [],
    articlesPaginatedPage: 0,
  })),
  on(ArticlesPaginatedSearch, (state: IArticlesState, { search }) => ({
    ...state,
    articlesPaginated: [],
    articlesPaginatedSearch: search,
    articlesPaginatedPage: 0,
  })),
  on(ArticlesPaginatedAppendInitialItems, (state: IArticlesState, { articlesPaginated } : { articlesPaginated : {articleId: string, name: string}[] }) => {
    return ({
      ...state,
      articlesPaginated: [...state.articlesPaginated, ...articlesPaginated],
    }) 
  }),

  on(ArticlesWithGestiuneLoaded, setArticlesWithGestiune),
  on(ArticlesWithGestiuneLoading, (state: IArticlesState) => ({
    ...state,
    articlesWithGestiuneLoading: true,
  })),
  on(ArticlesWithGestiuneNextPage, (state: IArticlesState) => ({
    ...state,
    articlesWithGestiunePage: state.articlesWithGestiunePage + 1,
  })),
  on(ArticlesWithGestiuneReset, (state: IArticlesState) => ({
    ...state,
    articlesWithGestiune: [],
    articlesWithGestiunePage: 0,
  })),
  on(ArticlesWithGestiuneSearch, (state: IArticlesState, { search }) => ({
    ...state,
    articlesWithGestiune: [],
    articlesWithGestiuneSearch: search,
    articlesWithGestiunePage: 0,
  })),
  on(ArticlesWithGestiuneAppendInitialItems, (state: IArticlesState, { articlesWithGestiune } : { articlesWithGestiune : {articleId: string, name: string}[] }) => {
    return ({
      ...state,
      articlesWithGestiune: [...state.articlesWithGestiune, ...articlesWithGestiune],
    })
  }),
  on(ArticlesForGestiuneConsumabileLoaded, setArticlesForGestiuneConsumabile),
  on(ArticlesForGestiuneConsumabileLoading, (s) => ({
    ...s,
    articlesForGestiuneConsumabileLoading: true,
  })),
  on(ArticlesForGestiuneConsumabileNextPage, (s) => ({
    ...s,
    articlesForGestiuneConsumabilePage: s.articlesForGestiuneConsumabilePage + 1,
  })),
  on(ArticlesForGestiuneConsumabileReset, (s) => ({
    ...s,
    articlesForGestiuneConsumabile: [],
    articlesForGestiuneConsumabilePage: 0,
  })),
  on(ArticlesForGestiuneConsumabileSearch, (s, { search }) => ({
    ...s,
    articlesForGestiuneConsumabile: [],
    articlesForGestiuneConsumabileSearch: search,
    articlesForGestiuneConsumabilePage: 0,
  })),
  on(ArticlesForGestiuneConsumabileAppendInitialItems, (s, { articlesForGestiune }) => ({
    ...s,
    articlesForGestiuneConsumabile: [...s.articlesForGestiuneConsumabile, ...articlesForGestiune],
  })),
  on(ArticlesWithGestiuneOnlySecondHand, (state: IArticlesState, { onlySecondHand } : { onlySecondHand : boolean }) => {
    return ({
      ...state,
      onlySecondHand
    })
  }),
);

export function articlesReducer(state: IArticlesState, action): IArticlesState {
  return _ArticlesReducer(state, action);
}
